import { Component, OnInit, ChangeDetectionStrategy, Input, OnDestroy, ViewChild, AfterViewInit } from '@angular/core';
import { ClientAutocompleteService } from './client-autocomplete.service';
import { FormGroup, AbstractControl } from '@angular/forms';
import { debounceTime, tap, distinctUntilChanged, filter, withLatestFrom } from 'rxjs/operators';
import { ClientAutocomplete } from './client-autocomplete';
import { merge, combineLatest } from 'rxjs';
import { BaseComponent } from '@morningstar/shared/base/base-component';
import { StorageService } from '@morningstar/shared/base/storage-service';
import { MatInput } from '@angular/material/input';

@Component({
  selector: 'wsg-client-autocomplete',
  templateUrl: './client-autocomplete.component.html',
  styleUrls: ['./client-autocomplete.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ClientAutocompleteComponent extends BaseComponent implements AfterViewInit, OnInit, OnDestroy {

  @Input() label = 'Client';
  @Input() parent: FormGroup;

  @ViewChild('client', { read: MatInput }) clientInput: MatInput;

  filteredClients$ = this.clientAutocompleteService.list$;
  isActive$ = this.clientAutocompleteService.isActive$;
  location$ = this.storageService.location$;
  client$ = this.storageService.client$;
  isFutureClient$ = this.storageService.futureClients$;
  storedClient$ = this.clientAutocompleteService.storedClient$;

  currentMSClient = null;

  onLocationChange$ = combineLatest([this.location$, this.storageService.msClient$]).pipe(
    filter(([location, msClient]) => {
      return location && this.clientAutocompleteService.currentLocation !== location ||
             this.currentMSClient !== msClient;
    }),
    tap(([location, msClient]) => {
      this.clientAutocompleteService.currentLocation = location;
      this.currentMSClient = msClient;
      this.clientAutocompleteService.getList(location, null, true);
    })
  );

  subscription = merge(
    this.onLocationChange$
  ).subscribe();

  constructor(private clientAutocompleteService: ClientAutocompleteService,
              private storageService: StorageService) {
    super(clientAutocompleteService);
  }

  ngOnInit() {
    this.subscription.add(this.client.valueChanges.pipe(
      distinctUntilChanged(),
      debounceTime(300),
      tap(value => this.filter(value))
    ).subscribe());

    this.subscription.add(this.clientAutocompleteService.storedClient$.subscribe(client =>
      this.setStoredClient(client)
    ));
  }

  ngAfterViewInit() {
    this.subscription.add(this.clientAutocompleteService.storedClient$.pipe(
      filter(client => !client),
      tap(client => {
        this.parent.get('client').setValue('')
      })
    ).subscribe());
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  filter(inputText: string): void {
    this.clientAutocompleteService.filter(inputText);
  }

  displayClient(client: ClientAutocomplete): string | undefined {
    return client ? client.sortName : undefined;
  }

  setStoredClient(storedClient: ClientAutocomplete){
    if (storedClient){
      this.client.setValue(storedClient);
    }
  }

  setIsActive(isActive: boolean) {
    this.clientAutocompleteService.setIsActive(isActive);
  }

  setFutureClients(isFutureClient: boolean) {
      this.clientAutocompleteService.setFutureClients(isFutureClient);
  }

  onClientChanged() {
    this.clientAutocompleteService.clientChanged.next();
  }

  get client(): AbstractControl {
    return this.parent.get('client');
  }
}
